import { evaluationGridTemplateService } from '@/services/evaluation-grid-templates.service';
import axios from 'axios';

const initialState = () => ({
  status: {
    error: null,
    pending: false,
    resolved: false,
    rejected: false,
  },
});

const state = initialState();

const actions = {
  addEvaluationGridTemplateField({ commit }, { templateId, fieldData }) {
    commit('ADD_EVALUATION_GRID_TEMPLATE_FIELD');
    return evaluationGridTemplateService.addField(templateId, fieldData).then(
      (data) => {
        commit('ADD_EVALUATION_GRID_TEMPLATE_FIELD_SUCCESS', data);
        return data;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('ADD_EVALUATION_GRID_TEMPLATE_FIELD_ERROR', error);
          throw error;
        }
      },
    );
  },
  deleteEvaluationGridTemplateField({ commit, dispatch }, { templateId, fieldId }) {
    commit('DELETE_EVALUATION_GRID_TEMPLATE_FIELD');
    return evaluationGridTemplateService.deleteField(templateId, fieldId).then(
      (data) => {
        commit('DELETE_EVALUATION_GRID_TEMPLATE_FIELD_SUCCESS');
        dispatch(
          'evaluationGridTemplates/_deleteEvaluationGridTemplateFields',
          { evaluationGridTemplateId: templateId, fieldIdToDelete: fieldId },
          { root: true },
        );
        return data;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('DELETE_EVALUATION_GRID_TEMPLATE_FIELD_ERROR', error);
          throw error;
        }
      },
    );
  },
  editEvaluationGridTemplateField({ commit, dispatch }, { templateId, fieldId, fieldData }) {
    commit('EDIT_EVALUATION_GRID_TEMPLATE_FIELD');
    return evaluationGridTemplateService.editField(templateId, fieldId, fieldData).then(
      (data) => {
        commit('EDIT_EVALUATION_GRID_TEMPLATE_FIELD_SUCCESS');
        dispatch(
          'evaluationGridTemplates/_updateEvaluationGridTemplateField',
          { evaluationGridTemplateId: templateId, updatedField: data },
          { root: true },
        );
        return data;
      },
      (error) => {
        if (!axios.isCancel(error)) {
          commit('EDIT_EVALUATION_GRID_TEMPLATE_FIELD_ERROR', error);
          throw error;
        }
      },
    );
  },
};

const mutations = {
  ADD_EVALUATION_GRID_TEMPLATE_FIELD(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  ADD_EVALUATION_GRID_TEMPLATE_FIELD_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  ADD_EVALUATION_GRID_TEMPLATE_FIELD_SUCCESS(state, data) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },

  DELETE_EVALUATION_GRID_TEMPLATE_FIELD(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  EDIT_EVALUATION_GRID_TEMPLATE_FIELD(state) {
    state.status = {
      error: null,
      pending: true,
      resolved: false,
      rejected: false,
    };
  },
  EDIT_EVALUATION_GRID_TEMPLATE_FIELD_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  EDIT_EVALUATION_GRID_TEMPLATE_FIELD_SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
  DELETE_EVALUATION_GRID_TEMPLATE_FIELD_ERROR(state, error) {
    state.status = {
      ...state.status,
      pending: false,
      rejected: true,
      error: error,
    };
  },
  DELETE_EVALUATION_GRID_TEMPLATE_FIELD_SUCCESS(state) {
    state.status = {
      ...state.status,
      pending: false,
      resolved: true,
    };
  },
};

const getters = {
  error: (state) => state.status.error,
  pending: (state) => state.status.pending,
  rejected: (state) => state.status.rejected,
  resolved: (state) => state.status.resolved,
};

export const evaluationGridTemplateFields = {
  namespaced: true,
  state,
  actions,
  mutations,
  getters,
};
